import * as React from 'react'

import { ReadAloudContent } from '../../../Shared/components/readAloud/readAloudContent'
import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility'

interface FollowupModalProps {
  goToLMS: any,
  goToFollowupPractice: any
}

const FollowupModal = ({ goToLMS, goToFollowupPractice, }: FollowupModalProps) => {
  const { modalRef } = useModalAccessibility(goToFollowupPractice);

  return (
    <div
      aria-labelledby='title'
      aria-live="polite"
      aria-modal={true}
      className="followup-modal-container"
      ref={modalRef}
      role="dialog"
      tabIndex={-1}
    >
      <div className="followup-modal-background" />
      <div className="followup-modal">
        <div className="top-section">
          <ReadAloudContent label="Read the message aloud"><h1 id="title">That&#39;s the end of this passage! Now let&#39;s do some follow-up practice.</h1></ReadAloudContent>
        </div>
        <div className="button-section">
          <button className="quill-button medium green outlined focus-on-light" onClick={goToLMS} type="button">Save and Exit</button>
          <button className="quill-button medium green contained focus-on-light" onClick={goToFollowupPractice} type="button">Begin</button>
        </div>
      </div>
    </div>
  )
}

export default FollowupModal
